<!-- conteneur de la vue principale -->
<ng-container *ngTemplateOutlet="!isMobile ? desktopView : mobileView">

</ng-container>
<!-- fin conteneur -->

<!-- nombre de view - si plus complexe ou utiliser ailleurs, le passer en composant -->
<ng-template #viewerCountTemplate>
  <div class="d-flex gap-8" ngbTooltip="{{ 'TOOLTIP.NB_VIEWERS' | translate }}"
    placement="{{ isMobile ? 'left-bottom' : 'top-end' }}"
    tooltipClass="nb_viewers" [ngClass]="{'align-items-baseline': !selectedRoom.badges}" *ngIf="viewerCount && viewerCount !== 0">
    <lf-icon class="lh-1" name="Eyes" height="15px" width="15px"></lf-icon>
    <div class="text-grad-red text_4 lh-1">{{ viewerCount }}</div>
  </div>
</ng-template>

<!-- Vue Desktop -->
<ng-template #desktopView>
  <!-- preloader -->
  <app-property-ph *ngIf="!selectedRoom"></app-property-ph>
  <div *ngIf="selectedRoom" class="d-flex flex-wrap content-container position-relative">

    <!--   Fil d'ariane page property   -->
    <div class="w-100 custom-top-bar mb-2 d-flex align-items-center w-100 padding-page padding-page-right">
      <div class="font-10 lightGray2 mb-1">
        <a class="lightGray2" href="{{ returnUrl('home') }}">{{ 'COMMON.HOMEPAGE' | translate }}</a>
        <span class="material-icons-outlined font-10 v-middle mx-2">chevron_right</span>
        <a class="lightGray2"
          href="{{ returnUrl('list') }}">{{ "PROCESSES.ACCOMMODATION.LIST.NB_ROOMS" | translate }}</a>
        <span class="material-icons-outlined font-10 v-middle mx-2">chevron_right</span>
        <a *ngIf="searchCity || selectedRoom.property_address.city" class="lightGray2" href="{{ returnUrl('city') }}">{{ searchCity ? searchCity : selectedRoom.property_address.city }}</a>
        <span *ngIf="searchCity ||selectedRoom.property_address.city" class="material-icons-outlined font-10 v-middle mx-2">chevron_right</span>
        <a class="lightGray2"
          href="{{ returnUrl('type') }}">{{ "PROCESSES.ACCOMMODATION.FILTER." + selectedRoom['partner_type'].toUpperCase() | translate }}</a>
      </div>

      <div class="d-flex icon-div m-auto">
        <lf-icon (click)="share()" class="share-icon icon-topbar" fillColor="#525458" height="24px" name="share"
          width="24px">
        </lf-icon>

        <app-btn-favorite [favoritList]="favList" [item]="selectedRoom" [propertyPage]="true"></app-btn-favorite>
      </div>
    </div>

    <div class="col-sm-12 col-lg-12 col-xl-12 lf-after-bg padding-page">
      <div class="pb-4">
        <h1 *ngIf="locale === 'fr' && selectedRoom" class="mt-3 mb-1 title_1">{{selectedRoom.seoFr}}</h1>
        <h1 *ngIf="locale === 'en' && selectedRoom" class="mt-3 mb-1 title_1">{{selectedRoom.seoEn}}</h1>
        <div class="txt-darkGray roomName font-18 mb-1 title_2" *ngIf="selectedRoom">
          <small class="font-trueno-bold d-flex align-items-baseline">
            {{ selectedRoom.name }}
            <span class="text_1 mediumGray text-nowrap"> - réf : {{ selectedRoom.id }}</span>
          </small>
          <div class="d-flex justify-content-between align-items-end">
            <span class="text_1 city mediumGray">{{selectedRoom.property_address.city}} {{selectedRoom.property_address.postal_code}}</span>
            <ng-container *ngTemplateOutlet="selectedRoom.badges ? null : viewerCountTemplate"></ng-container>

          </div>
        </div>
        <div class="d-flex justify-content-between align-items-end" *ngIf="selectedRoom?.badges">
          <app-item-badges [element]="selectedRoom"></app-item-badges>
          <ng-container *ngTemplateOutlet="viewerCountTemplate"></ng-container>
        </div>

      </div>
    </div>

    <div class="col-sm-12 col-lg-7 col-xl-7" *ngIf="selectedRoom">
      <app-component-property [FaqItems]="FaqItems" [favList]="favList"
        [room]="selectedRoom" [selectedCity]="searchCity" [userOngoingBookings]="onGoingBooking"
      ></app-component-property>
    </div>

    <!-- BLOC DETAILS PAIEMENT -->
    <div class="col-sm-12 col-lg-5 col-xl-5 padding-page padding-page-right">
      <div class="d-flex flex-column sticky-top scrollable br-16">
        <!--  Logement disponible   -->
        <ng-container *ngIf="selectedRoom?.disponibility; else notAvailable">
          <div class="d-lg-block br-16 bg-res-fixed font-trueno-light custom-padding">
            <!--  Le user a une réservation dessus   -->
            <ng-container *ngIf="onGoingBooking && onGoingBooking.status === 'Pending' ; else noReservationBlock">
              <h3 class="pb-0 title_4 mediumGray">
                {{ 'PROCESSES.ACCOMMODATION.CANDIDATE.PENDING_ONGOING_TITLE' | translate }}
              </h3>
              <p class="text_1 pb-4 mb-1 mt-3 mediumGray">
                {{ 'PROCESSES.ACCOMMODATION.CANDIDATE.PENDING_ONGOING_TEXT' | translate }}
              </p>
              <app-accommodation-payment-details [isAllSummaryOpen]="true" [isBtnDisplay]="false"
                [firstMonthRent]="firstMonthRent" [booking]="onGoingBooking"
                [selectedRoom]="selectedRoom"></app-accommodation-payment-details>
            </ng-container>
            <!--  Le user n'a pas de réservation dessus - réservation disponible  -->
            <ng-template #noReservationBlock>
              <div class="w-100 flex-column mt-2">
                <h2 class="txt-blue-sky mb-0 title_1 pb-2">
                  {{ this.selectedRoom.property_price.price | number: '1.0-0' }} €
                  <span class="price_paragraph subtitle_2">{{ 'REGISTRATION.HOUSING_BUDGET.COST_MONTH' | translate }}</span>
                </h2>
                <p class="text_1">
                  {{ 'PROCESSES.ACCOMMODATION.LIST.DISPONIBILITY_DATE' | translate }}
                  <span class="text-black text_4">{{this.selectedRoom.disponibility | date:(locale === 'fr' ? 'dd/MM/yyyy' : 'MM/dd/yyyy')}}</span>
                </p>
                <p class="text_1">
                  {{ 'PROCESSES.ACCOMMODATION.LIST.RENT_MINIMUM_DURATION' | translate }}
                  <span
                    class="text-black text_4">{{this.selectedRoom.minimal_stay_duration}} {{'COMMON.MONTH' | translate}}</span>
                </p>
              </div>

              <div class="pb-3 pt-4 font-trueno-light">
                <span class="subtitle_1">{{ 'PROCESSES.ACCOMMODATION.LIST.DATE_PICKER.TITLE' | translate }}</span>
                <div class="container-fluid container_date">
                  <div class="row justify-content-center align-content-center d-flex align-content-center pb-4 pt-3 text_3">
                    <div class="col-5">
                      <div (click)="showCalendar()"
                        class="col-date d-flex text_1 d-flex flex-column overflow-hidden pb-2">
                        <div class="title_3 mb-2 ps-2 py-1"
                          [ngClass]="{
                          'bg-grey mediumGray': (!isCalendarOpen && !rangeDate.start && !rangeDate.end),
                          'bg-grad-blue': isCalendarOpen && border === 'start',
                          'bg-mediumGray' : rangeDate.start
                          }">
                          {{ 'PROCESSES.ACCOMMODATION.LIST.DATE_PICKER.START_DATE' | translate }}
                        </div>

                        <span class="text-center" *ngIf="!rangeDate.start">Date</span>

                        <div class="mx-auto d-flex flex-row" *ngIf="rangeDate.start">
                          {{ startDateString }}
                          <button class="btn close_btn border-0 p-0 m-0 ms-1 d-flex align-items-center" (click)="deleteStartDate();$event.stopPropagation()">
                            <span class="material-icons-outlined btn-close-black">close</span>
                          </button>
                        </div>


                      </div>
                    </div>
                    <div class="col-2 d-flex align-items-center justify-content-center">
                      <lf-icon name="rarrowRight" height="16px" width="16px"></lf-icon>
                    </div>
                    <div class="col-5">
                      <div (click)="showCalendar()"
                        class="col-date d-flex text_1 d-flex flex-column overflow-hidden pb-2">
                        <div class="title_3 mb-2 ps-2 py-1"
                          [ngClass]="{
                          'bg-grey mediumGray': (!isCalendarOpen && !rangeDate.end),
                          'bg-grad-blue': isCalendarOpen && border === 'end',
                          'bg-mediumGray' : rangeDate.end
                          }">
                          {{ 'PROCESSES.ACCOMMODATION.LIST.DATE_PICKER.END_DATE' | translate }}
                        </div>
                        <span class="text-center" *ngIf="!rangeDate.end">Date</span>
                        <div class="mx-auto d-flex flex-row" *ngIf="rangeDate.end">
                          {{ endDateString }}
                          <button *ngIf="rangeDate.end" class="btn close_btn border-0 p-0 m-0 ms-1 d-flex align-items-center" (click)="deleteEndDate();$event.stopPropagation()">
                            <span class="material-icons-outlined btn-close-black">close</span>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div [ngClass]="{'d-none' : !isCalendarOpen}" class="calendarComponentFixed pt-3">
                      <input #bookingDatePicker="ngbDatepicker" [outsideDays]="'collapsed'" class="form-control d-none"
                        ngbDatepicker>
                      <app-calendar #CalendarComponent (click)="$event.stopPropagation()"
                        (dates)="checkBookingDate($event)" (endDate)="getEndDate($event)" (startDate)="getStartDate($event)" [d]="bookingDatePicker"
                        [isWeekendDisabled]="true"
                        [hideButton]="true"
                        [isContainer]="true"
                        [isRangeInput]="true"
                        [minDate]="minDate"
                        [maxDate]="maxDate"
                        [room]="selectedRoom"
                        [deleteStartDate]="deleteStartDateI"
                        [deleteEndDate]="deleteEndDateI"
                      ></app-calendar>

                    </div>
                  </div>

                  <div class="text-center pb-4">
                    <button #resaBox (click)="goToNext()"
                      [ngClass]="{'btn-candidate' : (rangeDate.start && rangeDate.end) || (!rangeDate.start && !isCalendarOpen)}"
                      class="btn btn-primary disabled_button title_3 text-white w-100 ms-auto border-0">
                      <span *ngIf="!isSummaryOpen">{{ "PROCESSES.ACCOMMODATION.BOOK.DISPONIBILITY" | translate }}</span>
                      <span
                        *ngIf="isSummaryOpen">{{ "PROCESSES.ACCOMMODATION.LIST.PAYMENT_SUMMARY.CONTINUE" | translate }}</span>
                    </button>
                    <div class="d-flex flex-column pt-2 text_2">
                      <small *ngIf="(!rangeDate.start && !rangeDate.end && isClicked)"
                        class="red-error">{{ "PROCESSES.ACCOMMODATION.BOOK.ERROR_DATES" | translate }}</small>
                      <small>{{ "PROCESSES.ACCOMMODATION.BOOK.NO_FEES" | translate }}</small>
                    </div>
                  </div>

                </div>


                <app-accommodation-payment-details *ngIf="isSummaryOpen"
                  [firstMonthRent]="firstMonthRent" [isAllSummaryOpen]="false"
                  [selectedRoom]="selectedRoom"></app-accommodation-payment-details>

                <div class="d-flex advantages-col align-items-center my-3 px-3 gap-16">
                  <app-lf-advantages [text]="'ROOM.ADVANTAGES.ROOM_VERIFIED'" [iconName]="'livinProtect'" [title]="'ROOM.ADVANTAGES.ROOM_VERIFIED_TITLE'"></app-lf-advantages>
                  <app-lf-advantages [text]="'ROOM.ADVANTAGES.GUARANTOR'" [iconName]="'livinGarantGray'" [title]="'ROOM.ADVANTAGES.GUARANTOR_TITLE'"></app-lf-advantages>
                </div>
              </div>
            </ng-template>
          </div>
        </ng-container>

        <!--  Logement loué   -->
        <ng-template #notAvailable>
          <!--  Logement loué par l'utilisateur   -->
          <ng-container *ngIf="onGoingBooking && onGoingBooking.status === 'Accepted' ; else noReservationBlock">
            <div class="d-lg-block br-16 bg-res-fixed font-trueno-light custom-padding">
              <h3 class="pb-0 title_4 mediumGray d-flex flex-row gap-16">
                {{ 'PROCESSES.ACCOMMODATION.CANDIDATE.ACCEPTED_TITLE' | translate }}
                <lf-icon class="lh-1" name="greenCheck" height="20px" width="20px"></lf-icon>
              </h3>
              <p class="text_1 mt-3 mediumGray">
                {{ 'PROCESSES.ACCOMMODATION.CANDIDATE.ACCEPTED_TEXT' | translate }}
              </p>
              <button class="btn btn-gradient-blue border-0 mt-3" type="button" (click)="goToProfile()">
                {{ 'PROCESSES.ACCOMMODATION.CANDIDATE.ACCEPTED_BTN' | translate }}
              </button>
            </div>
          </ng-container>
          <!--  Logement loué par un autre utilisateur   -->
          <ng-template #noReservationBlock>
            <div class="d-lg-block br-16 bg-res-fixed font-trueno-light custom-padding mb-3">
              <h3 class="pb-0 title_4 mediumGray">
                {{ 'PROCESSES.ACCOMMODATION.CANDIDATE.UNAVAILABLE_TITLE' | translate}}
              </h3>
              <p class="text_1 mt-3 mediumGray">
                {{ 'PROCESSES.ACCOMMODATION.CANDIDATE.UNAVAILABLE_TEXT' | translate}}
              </p>
            </div>
            <app-accommodation-alerts [wantedCity]="selectedRoom.property_address.city" [filters]="alertFilters"></app-accommodation-alerts>
          </ng-template>
        </ng-template>

      </div>
    </div>

    <div class="col-12 mt-5">
      <app-accommodation-item-card [otherRooms]="similarOffers" *ngIf="similarOffers && similarOffers.length > 0" [favList]="favList"
        [type]="'similarRooms'" [name]="'similarRoomsCard'"></app-accommodation-item-card>
    </div>

    <app-report-form [item]="selectedRoom" *ngIf="!isCrawler"></app-report-form>

  </div>
</ng-template>

<!-- Vue mobile -->
<ng-template #mobileView>
  <div class="position-relative mobile-page container-fluid" *ngIf="!selectedRoom">
    <app-property-ph></app-property-ph>
  </div>
  <div *ngIf="selectedRoom" class="row mx-0">
    <div
      [ngClass]="{'show' : showTopBarMobile}"
      class="sticky-top w-100 custom-top-bar custom-top-bar-mobile border-bottom border-2 mb-2 d-flex align-items-center p-3 bg-white">
      <lf-icon (click)="goBack()" fillColor="#525458" height="24px" name="rarrow"
        width="24px">
      </lf-icon>
      <div class="ms-auto d-flex">
        <lf-icon (click)="share()" class="share-icon icon-topbar" fillColor="#525458" height="24px" name="share"
          width="24px">
        </lf-icon>
        <app-btn-favorite [favoritList]="favList" [item]="selectedRoom" [propertyPage]="true"></app-btn-favorite>
      </div>

    </div>
    <div class="col-sm-12 col-lg-12 col-xl-12 lf-after-bg margin-page custom-col">
      <div class="pb-3">
        <h1 *ngIf="locale === 'fr'" class="mt-3 mb-2 title_1">{{selectedRoom.seoFr}}</h1>
        <h1 *ngIf="locale === 'en'" class="mt-3 mb-2 title_1">{{selectedRoom.seoEn}}</h1>
        <div class="txt-darkGray roomName font-18 mb-0 title_2">
          <small class="font-trueno-bold d-flex">
            {{ selectedRoom.name }}
            <span class="text_1 mediumGray"> - réf : {{ selectedRoom.id }}</span>
          </small>
          <div class="d-flex justify-content-between">
            <span class="text_1 city mediumGray">{{selectedRoom.property_address.city}} {{selectedRoom.property_address.postal_code}}</span>
            <ng-container *ngTemplateOutlet="selectedRoom.badges ? null : viewerCountTemplate"></ng-container>

          </div>
        </div>
        <div class="d-flex justify-content-between" *ngIf="selectedRoom.badges">
          <app-item-badges [element]="selectedRoom"></app-item-badges>
          <ng-container *ngTemplateOutlet="viewerCountTemplate"></ng-container>
        </div>

      </div>
    </div>
    <div class="col-sm-12 col-lg-6 col-xl-5 offset-xl-1 lf-after-bg h-100 w-100 pe-0 ps-0">
      <app-component-property [userOngoingBookings]="onGoingBooking" [FaqItems]="FaqItems" [favList]="favList"
        [room]="selectedRoom" [selectedCity]="searchCity"></app-component-property>

      <div class="col-12 margin-page mt-5 mobile_bot_padding">
        <app-accommodation-item-card [otherRooms]="similarOffers" *ngIf="similarOffers && similarOffers.length > 0" [favList]="favList"
          [type]="'similarRooms'" [name]="'similarRoomsCard'"></app-accommodation-item-card>
        <app-report-form [item]="selectedRoom" *ngIf="!isCrawler"></app-report-form>
      </div>
    </div>

    <!------------------------------ CALENDAR ------------------------------>
    <div class="position-fixed w-100 bg-res-fixed m-fixed-res_btn pt-2 px-0 overflow-auto hidden-scrollbar d-flex flex-column"
      [ngClass]="{'open': isMobileCalendarOpen}">
      <div #calendarMenu
        [ngClass]="{'show': isMobileCalendarOpen, 'show-pb': showFixedButton, 'd-none': !isMobileCalendarOpen}"
        class="container-fluid d-flex flex-column px-0">
        <div class="d-flex justify-content-end px-2">
          <button class="btn border-0 mb-3" type="button" (click)="mobileShowPayment = false;this.closeCalendar()">
            <lf-icon name="cross" height="12px" fillColor="#000000" width="12px"></lf-icon>
          </button>
        </div>

        <span class="subtitle_1 px-4">{{ 'PROCESSES.ACCOMMODATION.LIST.DATE_PICKER.TITLE' | translate }}</span>

        <div class="row justify-content-center align-content-center d-flex align-content-center pb-5 pt-3 px-4 m-0">
          <div class="col-5 px-0 mx-0">
            <div (click)="openCalendarMobile()"
              class="col-date d-flex text_1 d-flex flex-column overflow-hidden pb-2">
              <div class="title_3 mb-2 ps-2 py-1"
                [ngClass]="{
                  'bg-grey mediumGray': (!isCalendarOpen && !rangeDate.start && !rangeDate.end),
                  'bg-grad-blue': isCalendarOpen && border === 'start',
                  'bg-mediumGray' : rangeDate.start
                }">
                {{ 'PROCESSES.ACCOMMODATION.LIST.DATE_PICKER.START_DATE' | translate }}
              </div>
              <span class="text-center" *ngIf="!rangeDate.start">Date</span>
              <div class="mx-auto d-flex flex-row" *ngIf="rangeDate.start">
                {{ rangeDate.start }}
                <button class="btn close_btn border-0 p-0 m-0 ms-1 d-flex align-items-center" (click)="deleteStartDate();$event.stopPropagation()">
                  <span class="material-icons-outlined btn-close-black">close</span>
                </button>
              </div>
            </div>
          </div>

          <div class="col-2 p-0 m-0 d-flex align-items-center justify-content-center h-100">
            <lf-icon name="rarrowRight" height="16px" width="16px"></lf-icon>
          </div>

          <div class="col-5 px-0 mx-0">
            <div (click)="openCalendarMobile()"
              class="col-date d-flex text_1 d-flex flex-column overflow-hidden pb-2">
              <div class="title_3 mb-2 ps-2 py-1"
                [ngClass]="{
                'bg-grey mediumGray': (!isCalendarOpen && !rangeDate.end),
                'bg-grad-blue': isCalendarOpen && border === 'end',
                'bg-mediumGray' : rangeDate.end
                }">
                {{ 'PROCESSES.ACCOMMODATION.LIST.DATE_PICKER.END_DATE' | translate }}
              </div>
              <span class="text-center" *ngIf="!rangeDate.end">Date</span>
              <div class="mx-auto d-flex flex-row" *ngIf="rangeDate.end">
                {{ rangeDate.end }}
                <button *ngIf="rangeDate.end" class="btn close_btn border-0 p-0 m-0 ms-1 d-flex align-items-center" (click)="deleteEndDate();$event.stopPropagation()">
                  <span class="material-icons-outlined btn-close-black">close</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-grow-1 pb-4 w-100" [ngClass]="{'d-none': isSummaryOpen}">
          <input class="d-none" ngbDatepicker #bookingDatePicker="ngbDatepicker" [outsideDays]="'collapsed'">
          <app-calendar #CalendarComponent class="mobile_calendar" (click)="$event.stopPropagation()"
            [isContainer]="true" [isRangeInput]="true" [d]="bookingDatePicker" [hideButton]="true"
            [isWeekendDisabled]="true"
            [minDate]="minDate"
            (dates)="checkBookingDate($event)"
            (startDate)="getStartDate($event)"
            (endDate)="getEndDate($event)" [room]="selectedRoom"
            [deleteStartDate]="deleteStartDateI"
            [deleteEndDate]="deleteEndDateI"
          ></app-calendar>
        </div>

        <app-accommodation-payment-details class="mx-3" *ngIf="isSummaryOpen"
          [firstMonthRent]="firstMonthRent" [isAllSummaryOpen]="true"
          [selectedRoom]="selectedRoom"></app-accommodation-payment-details>

      </div>

      <!---------- dispo quand le logement est en pending pour le user     -->
      <div class="bg-white p-3" *ngIf="mobileShowPayment">
        <app-accommodation-payment-details #paymentBox [booking]="onGoingBooking"
          [firstMonthRent]="firstMonthRent" [isBtnDisplay]="false" [isAllSummaryOpen]="true"
          [selectedRoom]="selectedRoom"></app-accommodation-payment-details>
        <div class="d-flex advantages-col align-items-center my-3 gap-16">
          <app-lf-advantages [text]="'ROOM.ADVANTAGES.ROOM_VERIFIED'" [iconName]="'livinProtect'" [title]="'ROOM.ADVANTAGES.ROOM_VERIFIED_TITLE'"></app-lf-advantages>
          <app-lf-advantages [text]="'ROOM.ADVANTAGES.GUARANTOR'" [iconName]="'livinGarantGray'" [title]="'ROOM.ADVANTAGES.GUARANTOR_TITLE'"></app-lf-advantages>
        </div>
      </div>

      <!---------- ALWAYS DISPLAY : btn principal,mini de résa, dispo, prix      -->
      <div class="d-flex flex-row gap-16 align-items-center py-3 px-4 sticky-bottom bg-grey mt-auto">
        <!--  Logement disponible   -->
        <ng-container *ngIf="selectedRoom.disponibility; else notAvailable">
          <!--  Le user a une réservation dessus   -->
          <ng-container *ngIf="onGoingBooking && onGoingBooking.status === 'Pending' ; else noReservationBlock">
            <div>
              <h3 class="pb-0 title_2 mediumGray">
                {{ 'PROCESSES.ACCOMMODATION.CANDIDATE.PENDING_ONGOING_TITLE' | translate }}
              </h3>
              <p class="text_1 mt-3 mediumGray">
                {{ 'PROCESSES.ACCOMMODATION.CANDIDATE.PENDING_ONGOING_TEXT' | translate }}
              </p>
            </div>
            <button class="btn btn-lf-secondary" type="button" (click)="mobileShowPayment = !mobileShowPayment">
              {{ ('PROCESSES.ACCOMMODATION.LIST.PAYMENT_SUMMARY.BTN_' + (mobileShowPayment ? 'CLOSE' : 'OPEN')) | translate }}
            </button>
          </ng-container>
          <!--  Le user n'a pas de réservation dessus - réservation disponible  -->
          <ng-template #noReservationBlock>
            <div class="w-100 d-flex">
              <div class="w-50 m-auto">
                <h2 class="txt-blue-sky mb-0 title_1">
                  {{selectedRoom.price}} €
                  <span class="price_paragraph subtitle_2">{{ 'REGISTRATION.HOUSING_BUDGET.COST_MONTH' | translate }}</span>
                </h2>
                <p class="text_1" [contentEditable]="getBoolean(currentUser && currentUser.isGhost)">
                  {{ 'PROCESSES.ACCOMMODATION.LIST.DISPONIBILITY_DATE' | translate }}
                  <span class="text-black text_4">{{(selectedRoom.disponibility) | date:(locale === 'fr' ? 'dd/MM/yyyy' : 'MM/dd/yyyy')}}</span>
                </p>
                <p class="text_1">
                  <span class="text-black text_4">{{selectedRoom.minimal_stay_duration ? selectedRoom.minimal_stay_duration : '3' }}
                    {{'COMMON.MONTH' | translate}}
                  </span>
                  {{ 'PROCESSES.ACCOMMODATION.LIST.RENT_MINIMUM_DURATION_MOBILE' | translate }}
                </p>
              </div>
              <div class="m-auto d-flex flex-column align-items-center pt-1">
                <button #resaBox2 class="btn btn-primary disabled_button subtitle_1 text-white w-100 ms-auto text-nowrap border-0" [ngClass]="{'btn-candidate' : (rangeDate.start && rangeDate.end) || (!rangeDate.start && !isCalendarOpen)}" (click)="goToNext()">
                  {{ !isSummaryOpen ? ("PROCESSES.ACCOMMODATION.BOOK.DISPONIBILITY" | translate) : ("PROCESSES.ACCOMMODATION.LIST.PAYMENT_SUMMARY.CONTINUE" | translate) }}
                </button>

                <div class="d-flex text_2 flex-column pt-2">
                  <small class="red-error" *ngIf="(!rangeDate.start && !rangeDate.end && isClicked)">{{ "PROCESSES.ACCOMMODATION.BOOK.ERROR_DATES" | translate }}</small>
                  <small class="">{{ "PROCESSES.ACCOMMODATION.BOOK.NO_FEES" | translate }}</small>
                </div>
              </div>
            </div>
          </ng-template>
        </ng-container>

        <!--  Logement loué   -->
        <ng-template #notAvailable>
          <!--  Logement loué par l'utilisateur   -->
          <ng-container *ngIf="onGoingBooking && onGoingBooking.status === 'Accepted' ; else noReservationBlock">
            <div>
              <h3 class="pb-0 title_2 mediumGray d-flex flex-row gap-8">
                {{ 'PROCESSES.ACCOMMODATION.CANDIDATE.ACCEPTED_TITLE' | translate }}
                <lf-icon class="lh-1" name="greenCheck" height="16px" width="16px"></lf-icon>
              </h3>
              <p class="text_1 mt-3 mediumGray">
                {{ 'PROCESSES.ACCOMMODATION.CANDIDATE.ACCEPTED_TEXT' | translate }}
              </p>
            </div>
            <button class="btn btn-gradient-blue border-0 mt-3 px-0" type="button" (click)="goToProfile()">
              {{ 'PROCESSES.ACCOMMODATION.CANDIDATE.ACCEPTED_BTN' | translate }}
            </button>
          </ng-container>
          <!--  Logement loué par un autre utilisateur   -->
          <ng-template #noReservationBlock>
            <div>
              <h3 class="pb-0 title_2 mediumGray">
                {{ 'PROCESSES.ACCOMMODATION.CANDIDATE.UNAVAILABLE_TITLE' | translate}}
              </h3>
              <p class="text_1 mt-3 mediumGray">
                {{ 'PROCESSES.ACCOMMODATION.CANDIDATE.UNAVAILABLE_TEXT' | translate}}
              </p>
            </div>
            <app-accommodation-alerts [filters]="alertFilters" [wantedCity]="selectedRoom.property_address.city" [showText]="false"></app-accommodation-alerts>
          </ng-template>
        </ng-template>
      </div>
    </div>

  </div>
</ng-template>
